module.exports = __webpack_public_path__ + "static/media/finecontrol.aef92ee8.svg";